import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {BatchDialogService} from "../../../batch/services/batch-dialogs-service.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";

export class OmsImportViewController implements IController {
  schemaDefaultFields: any;
  schemas: any;

  private uploadComplete = undefined;
  private orders = undefined;
  private errorOrders = undefined;
  private warningOrders = undefined;
  private currentNavItem = undefined;
  private editingOrder = undefined;
  private totals = undefined;
  private selectedIds = undefined;
  private queryString = undefined;
  private allowUpdateDuplicateOrders: boolean = false;
  public isFieldMappingOpen: boolean;


  /* @ngInject */
  constructor(private omsDialogService: OmsDialogService, private batchDialogService: BatchDialogService, private deliveriesAlertsService: DeliveriesAlertsService, private $timeout: ITimeoutService,
              private confirmDialogService: ConfirmDialogService, private confirmChangeStateService: ConfirmChangeStateService, private omsConstants, private $state,
              private splitService: SplitService, private $log, private UUIDService, private batchRequestsService: BatchRequestsService,
              private bringozLoaderService: BringozLoaderService, private omsOrdersAlertsService: OmsOrdersAlertsService) {
  }

  $onInit() {
    this.uploadComplete = false;
    this.currentNavItem = 'total';
    this.selectedIds = [];
    this.orders = [];
    this.errorOrders = [];
    this.warningOrders = [];
    this.totals = {};
  }

  changeNavItem(item) {
    this.currentNavItem = item;

    this.editingOrder = undefined;
    this.errorOrders = [];
    this.warningOrders = [];
    this.selectedIds = [];

    if (item === 'total') {
      this.orders = this.resetOrders(this.orders, this.getErrorOrders(this.orders), this.getWarningErrors(this.orders));
    }
    if (item === 'errors') {
      this.errorOrders = this.getErrorOrders(this.orders);
    }
    if (item === 'warnings') {
      this.warningOrders = this.getWarningErrors(this.orders);
    }
  }

  onUpload(event) {
    this.omsDialogService.importOrders(event, undefined, this.schemas)
      .then((orders) => {
        orders = this.setAllOrdersIds(orders);
        this.orders = this.orders.concat(orders);
        if (this.currentNavItem === 'errors') {
          this.errorOrders = this.getErrorOrders(this.orders);
        }
        if (this.currentNavItem === 'warnings') {
          this.warningOrders = this.getWarningErrors(this.orders);
        }
        this.totals = this.getTotals(this.orders);
        this.uploadComplete = true;
        this.confirmChangeStateService.setIsEnabled(true);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to upload file @uploadDeliveriesButton@onUpload', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onSelectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onRemoveOrders(ids) {
    this.orders = _.filter(this.orders, (order) => {
      return _.indexOf(ids, order.orderId) === -1;
    });
    this.totals = this.getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveErrorOrders(ids) {
    this.errorOrders = _.filter(this.errorOrders, (order) => {
      return _.indexOf(ids, order.orderId) === -1
    });
    this.orders = this.resetOrders(this.orders, this.errorOrders, this.getWarningErrors(this.orders));
    this.totals = this.getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveWarningOrders(ids) {
    this.warningOrders = _.filter(this.warningOrders, (order) => {
      return _.indexOf(ids, order.orderId) === -1
    });
    this.orders = this.resetOrders(this.orders, this.getErrorOrders(this.orders), this.warningOrders);
    this.totals = this.getTotals(this.orders);
    if (!this.orders.length) {
      this.uploadComplete = false;
    }
  }

  onEditOrder(order) {
    this.editingOrder = angular.copy(order);
  }

  onCancelEditing() {
    this.editingOrder = undefined;
  }

  onSaveEditing(editingOrder) {
    if (this.currentNavItem === 'errors') {
      const updatedErrorOrders = this.updateOrder(this.errorOrders, editingOrder);
      this.orders = this.resetOrders(this.orders, updatedErrorOrders, this.getWarningErrors(this.orders));

      this.errorOrders = _.filter(updatedErrorOrders, (order) => {
        return order.orderId !== editingOrder.orderId;
      });
    }
    if (this.currentNavItem === 'warnings') {
      this.warningOrders = this.updateOrder(this.warningOrders, editingOrder);
      this.orders = this.resetOrders(this.orders, this.getErrorOrders(this.orders), this.warningOrders);
    } else {
      this.orders = this.updateOrder(this.orders, editingOrder);
    }
    this.editingOrder = undefined;
    this.totals = this.getTotals(this.orders);
  }

  onMultipleDelete(ids) {
    if (this.currentNavItem === 'errors') {
      this.onRemoveErrorOrders(ids);
    }
    if (this.currentNavItem === 'warnings') {
      this.onRemoveWarningOrders(ids);
    } else {
      this.onRemoveOrders(ids);
    }
    this.selectedIds = [];
  }

  onCancel(event) {
    return this.confirmDialogService.confirm('Cancel Upload', 'Are you sure you want to cancel upload and reset all orders?', event)
      .then(() => {
        this.orders = [];
        this.errorOrders = [];
        this.currentNavItem = 'total';

        this.totals = {};
        this.selectedIds = [];
        this.uploadComplete = false;
        this.confirmChangeStateService.reset();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreate(event) {
    const orders = _.map(angular.copy(this.orders), (order) => {
      // order.confirm = true;
      return order.entity;
    });
    const serverErrorsCount = this.getWarningErrors(orders).length;
    this.confirmCreate(serverErrorsCount, event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.batchRequestsService.createOmsBatch(this.orders, this.allowUpdateDuplicateOrders);
      })
      .then((batch) => {
        this.bringozLoaderService.off();
        return this.batchDialogService.batchOmsProgress(event, batch);
      })
      .then((errorItems) => {
        this.$timeout(0).then(() => {

          if(!errorItems.length) {
            this.omsOrdersAlertsService.uploadSuccess();
            this.confirmChangeStateService.setIsEnabled(false);
            this.$state.go('orders.table');
          } else {
            let errorRowNumbers = _.map(errorItems, 'rowNumber');

            let errorOrders = _.chain(this.orders)
              .filter((o) => {
                return _.includes(errorRowNumbers, o.rowNumber)
              })
              .map((filteredOrder) => {
                var errorItem = _.find(errorItems, (errorItem) => {
                  return filteredOrder.rowNumber === errorItem.rowNumber;
                })
                filteredOrder.mappingErrors = _.get(errorItem, 'mappingErrors', []);
                return filteredOrder;
              })
              .value();

            errorOrders = this.setAllOrdersIds(errorOrders);
            this.orders = errorOrders;
            this.totals = this.getTotals(errorOrders);
            if (this.currentNavItem === 'errors') {
              this.errorOrders = this.getErrorOrders(errorOrders);
            }
            if (this.currentNavItem === 'warnings') {
              this.warningOrders = this.getWarningErrors(errorOrders);
            }
            if (!this.orders.length) {
              this.uploadComplete = false;
              this.confirmChangeStateService.setIsEnabled(false);
            }
          }
        })
      })
      .catch((error) => {
        if (error) {
          this.deliveriesAlertsService.createDeliveriesError();
          this.$log.error('Failed to create batch @uploadDeliveriesView@onCreate', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  onDownloadExample() {
    const downloadUrl = this.omsConstants.importSampleFileLink;
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "import-orders-example.xls";
    document.body.appendChild(a);
    a.click();
  }

  onCloseFieldMappingPanel() {
    this.isFieldMappingOpen = false;
  }

  onSchemaCreated(schema) {
    const schemasCopy = angular.copy(this.schemas);
    schemasCopy.push(schema);
    this.schemas = schemasCopy;
  }

  onSchemaUpdated(schema) {
    const schemasCopy = angular.copy(this.schemas);
    const schemaIndex = schemasCopy.findIndex(s => s.id === schema.id);
    schemasCopy.splice(schemaIndex, 1, schema);
    this.schemas = schemasCopy;
  }

  onSchemaDeleted(schemaId) {
    const schemasCopy = angular.copy(this.schemas);
    const schemaIndex = schemasCopy.findIndex(s => s.id === schemaId);
    schemasCopy.splice(schemaIndex, 1);
    this.schemas = schemasCopy;
  }

  private setAllOrdersIds(orders) {
    return _.map(orders, (order, index) => {
      order.orderId = index + '-' + this.UUIDService.generate();
      return order;
    })
  }

  private getTotals(orders) {
    const errors = _.reduce(orders, (sum, order) => {
      const error = _.find(_.get(order, 'mappingErrors', []), function (e) {
        return e.type === 'Error';
      });
      return sum + (error ? 1 : 0);
    }, 0);
    const warnings = _.reduce(orders, (sum, order) => {
      const warning = _.find(_.get(order, 'mappingErrors', []), function (e) {
        return e.type === 'Warning';
      });
      return sum + (warning ? 1 : 0);
    }, 0);
    return {
      total: orders.length,
      errors: errors,
      warnings: warnings
    }
  }

  private getErrorOrders(orders) {
    return _.filter(orders, (order) => {
      const error = _.find(_.get(order, 'mappingErrors', []), (e) => {
        return e.type === 'Error';
      });
      return !!error;
    });
  }

  private getWarningErrors(orders) {
    return _.filter(orders, (order) => {
      const warning = _.find(_.get(order, 'mappingErrors', []), function (e) {
        return e.type === 'Warning';
      });
      return !!warning;
    })
  }

  private updateOrder(orders, editingOrder) {
    return _.map(orders, (order) => {
      if (order.orderId === editingOrder.orderId) {
        return editingOrder;
      }
      return order;
    });
  }

  private resetOrders(orders, errorOrders, warningOrders) {
    const filteredOrders = _.filter(orders, (order) => {
      return !order.mappingErrors || !order.mappingErrors.length;
    });
    return _
      .chain(filteredOrders)
      .concat(errorOrders, warningOrders)
      .uniqWith(_.isEqual)
      .value();
  }

  private confirmCreate(serverErrorsCount, event) {
    return serverErrorsCount > 0 ?
      this.confirmDialogService.confirm('Unhandled Warning',
        'There are some unhandled warnings, are you sure you want to continue?', event) :
      Promise.resolve();
  }
}

angular
  .module('bringoz.admin.oms')
  .component('omsImportView', {
    bindings: {
      schemaDefaultFields: '<?',
      schemas: '<?'
    },
    template: require('./oms-import-view.html').default,
    controller: OmsImportViewController
  });
